import { lazy, Suspense } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import MainPage from "./Pages/MainPage";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./Admin/AdminComponents/AuthProvider";
import ProtectedRoute from "./Admin/AdminComponents/ProtectedRoute";
import { MascotProvider } from "./context/MascotContext";
import MascotLayer from "./components/Mascot/MascotLayer";
import PortfolioChatbot from "./components/PortfolioChatbot";
import EasterEggEngine from "./components/EasterEggEngine";
import CaseStudyTaskMaster from "./Pages/CaseStudyTaskMaster";

const ProjectPage = lazy(() => import("./Pages/ProjectPage"));
const Admin = lazy(() => import("./Admin/AdminPages/Admin"));
const Auth = lazy(() => import("./Admin/AdminPages/Auth"));
const NeoPlayground = lazy(() => import("./Pages/NeoPlayground"));

// Loading fallback component
const PageLoader = () => (
  <div className="w-full h-screen bg-[#030014] flex flex-col items-center justify-center gap-4">
    <div className="w-12 h-12 border-4 border-indigo-500/20 border-t-indigo-500 rounded-full animate-spin"></div>
    <p className="text-gray-500 text-xs font-mono tracking-widest animate-pulse">LUNA IS LOADING...</p>
  </div>
);

const queryClient = new QueryClient();

function App() {
  document.title = "Ritesh Ranjan";

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <MascotProvider>
          <BrowserRouter>
            <MascotLayer />
            <PortfolioChatbot />
            <EasterEggEngine />
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<MainPage />} />
                <Route path="/neo-playground" element={<NeoPlayground />} />
                <Route path="/project" element={<ProjectPage />} />
                <Route path="/case-study/taskmaster-pro" element={<CaseStudyTaskMaster />} />
                <Route path="/admin/auth" element={<Auth />} />
                <Route path="/auth" element={<Auth />} />

                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <Admin />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<MainPage />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </MascotProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;